import { movies } from '@/mocks/movies';

export default function StatsSection() {
  const totalEpisodes = movies.reduce((sum, m) => sum + m.episodeCount, 0);
  const totalViews = movies.reduce((sum, m) => sum + m.views, 0);
  const avgRating = (movies.reduce((sum, m) => sum + m.rating, 0) / movies.length).toFixed(1);

  const stats = [
    {
      label: '电视剧资源',
      value: `${movies.length}+`,
      suffix: '部',
      icon: 'ri-movie-line',
    },
    {
      label: '高清剧集',
      value: `${totalEpisodes}+`,
      suffix: '集',
      icon: 'ri-clapperboard-line',
    },
    {
      label: '累计播放',
      value: `${(totalViews / 10000).toFixed(0)}万+`,
      suffix: '次',
      icon: 'ri-play-circle-line',
    },
    {
      label: '平均评分',
      value: avgRating,
      suffix: '分',
      icon: 'ri-star-line',
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-foreground-950">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-500/15">
                <i className={`${stat.icon} text-xl text-accent-400`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading text-background-50 mb-1">
                {stat.value}
                <span className="text-sm text-background-400 ml-1">{stat.suffix}</span>
              </div>
              <p className="text-sm text-background-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}